/* global window */

export default function userBarDirective() {
  return {
    template: require('./user-bar.html'),
    controller: 'userBarController',
    controllerAs: 'userBarVM',
    bindToController: true,
    replace: true,
    scope: {},
    link: linkFunction
  };
}

/**
 * Set functionality to close both global notifications menu
 * and contextual help menu if the user clicks outside of them
 * @param scope
 * @param element
 */
function linkFunction(scope) {
  scope.contextualHelpNavActive = false;
  scope.userBarVM.toggleMenuVisibility = (type) => {
    scope.userBarVM[`${type}Active`] = !scope.userBarVM[`${type}Active`];
  };
  const everywhere = angular.element(window.document);

  everywhere.bind('click', (event) => {
    const contextualHelpClicked = angular.element(
      event.target
    ).hasClass('contextual-help-button');

    if (!contextualHelpClicked) {
      scope.userBarVM.contextualHelpNavActive = false;
    }
    scope.$apply();
  });
}
